$(".opt_Color .select .select__select").on("change", function () {
  var text = $(this).find("option:selected").attr("value");
  $(".product_tile_color_holder .image-var").each(function (index) {
    var text1 = $(this).attr("var-title");
    if (text == text1) {
      $(this).addClass("show-active");
      $(this).siblings().removeClass("show-active");
    }
  });
});

$(document).on("click", "button.size_main-btn", function () {
  $(this).parents(".size-chart").addClass("show_size");
  $(".size-pro-data").addClass("open-size");
});
$(document).on("click", ".size-close svg", function () {
  $(this).parents(".size-chart").removeClass("show_size");
  $(".size-pro-data").removeClass("open-size");
});






// ==============  Comment out the following block to prevent automatic image change on collection pages ================


$(document).ready(function () {
  $("body.collection .collection ul#product-grid li.grid__item").each(function (
    index
  ) {
    var url = $(this)
      .children(".card-wrapper")
      .children(".card.card--standard")
      .children(".card__content")
      .children(".main_card")
      .find(".product_tile_color_holder .color_sw:first-child")
      .attr("image_attr");
    if (url == "") {
    } else {
      $(this)
        .children(".card-wrapper")
        .children(".card.card--standard")
        .children(".card__content")
        .children(".main_card")
        .find(".product_tile_color_holder .color_sw:first-child")
        .addClass("selected_item");
      $(this)
        .children(".card-wrapper")
        .children(".card.card--standard")
        .children(".card__inner")
        .children(".card__media")
        .find(".media img")
        .attr("srcset", url);
    }
  });

  var text = $(
    '.opt_Color .select .select__select option[selected="selected"]'
  ).attr("value");
  $(".product_tile_color_holder .image-var").each(function (index) {
    var text1 = $(this).attr("var-title");
    if (text == text1) {
      $(this).addClass("show-active");
      $(this).siblings().removeClass("show-active");
    }
  });

  $("body.search ul.main_ser li.grid__item").each(function (index) {
    var url = $(this)
      .children(".card-wrapper")
      .children(".card.card--standard")
      .children(".card__content")
      .children(".main_card")
      .find(".product_tile_color_holder .color_sw:first-child")
      .attr("image_attr");
    if (url == "") {
    } else {
      $(this)
        .children(".card-wrapper")
        .children(".card.card--standard")
        .children(".card__content")
        .children(".main_card")
        .find(".product_tile_color_holder .color_sw:first-child")
        .addClass("selected_item");
      $(this)
        .children(".card-wrapper")
        .children(".card.card--standard")
        .children(".card__inner")
        .children(".card__media")
        .find(".media img")
        .attr("srcset", url);
    }
  });

});


// ==============  Comment out the above block to prevent automatic image change on collection pages ================










$(".product_tile_color_holder .color_sw").click(function () {
  $(this).addClass("selected_item");
  $(this).siblings().removeClass("selected_item");
  var image = $(this).attr("image_attr");
  $(this)
    .parents(".card__content")
    .siblings(".card__inner")
    .children(".card__media")
    .find(".media img")
    .attr("srcset", image);
  $(this)
    .parents(".product_tile_color_holder")
    .siblings("a")
    .find(".image-coll")
    .find("img.primary-img")
    .attr("src", image);
  $(this)
    .parents(".product_tile_color_holder")
    .siblings("a")
    .find(".image-coll")
    .find("img.secondary-img")
    .attr("src", image);
});

$(document).on(
  "click",
  "product-recommendations .card__information.main_card .product_tile_color_holder input",
  function () {
    $(this).addClass("selected_item");
    $(this).siblings().removeClass("selected_item");
    var src = $(this).attr("image_attr");
    $(this)
      .parents(".card__content")
      .siblings(".card__inner")
      .children(".card__media")
      .children(".media")
      .find(".main_first_img")
      .attr("src", src);
    $(this)
      .parents(".card__content")
      .siblings(".card__inner")
      .children(".card__media")
      .children(".media")
      .find(".main_first_img")
      .attr("srcset", src);
  }
);

$(document).on("click", ".accod-head h4", function () {
  $(this).parents(".main-accod").toggleClass("show_des");
});

/* product gallery slider start */

$(".coll-mg-gl").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  asNavFor: ".col-thumb-main",
});
$(".col-thumb-main").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: ".coll-mg-gl",
  dots: false,
  vertical: true,
  verticalSwiping: true,
});

/* product gallery slider end */

// $(document).on(
//   "click",
//   ".main-div-loop .product_tile_color_holder .image-var img",
//   function () {
//     $(this).addClass("show-active");
//     $(this).siblings().removeClass("show-active");
//     var id = $(this).parent(".image-var").attr("var-id");
//     var currentUrl = window.location.href;
//     if (currentUrl.indexOf("?") > -1) {
//       currentUrl = currentUrl.replace(/(\?|\&)variant=[^&]+/, "");
//       currentUrl += "?variant=" + id;
//     } else {
//       currentUrl += "?variant=" + id;
//     }
//     window.location.href = currentUrl;
//   }
// );

$(document).on(
  "click",
  ".main-div-loop .product_tile_color_holder .image-var img",
  function () {
    $(this).addClass("show-active");
    $(this).siblings().removeClass("show-active");
    var title = $(this).parent(".image-var").attr("var-title");
    var val = $(".opt_Size select").val();
    $(".main-swa .hide-div-gift .vardata-coll").each(function (index) {
      var otp1 = $(this).attr("var_option1");
      var otp2 = $(this).attr("var_option2");
      if (title == otp1 && val == otp2) {
        var id = $(this).attr("vargift_id");
        var currentUrl = window.location.href;
        if (currentUrl.indexOf("?") > -1) {
          currentUrl = currentUrl.replace(/(\?|\&)variant=[^&]+/, "");
          currentUrl += "?variant=" + id;
        } else {
          currentUrl += "?variant=" + id;
        }
        window.location.href = currentUrl;
      }
    });
  }
);

// $(document).ready(function () {
//   // Set the first option as selected
//   $(".opt_Size select option:first-child").attr("selected", "selected");
//   // Remove the 'selected' attribute from all other options
//   $(".opt_Size select option").not(":first-child").removeAttr("selected");
// });

$(".desk_top_gl").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  centerMode: false,
  prevArrow:
    "<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0806/1308/1387/files/left-chevron.png?v=1715172263'/></button>",
  nextArrow:
    "<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0806/1308/1387/files/chevron.png?v=1715172263'/></button>",
});

$(".mobile_gl_dsk").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  centerMode: false,
  prevArrow:
    "<button type='button' class='slick-prev'><img src='https://cdn.shopify.com/s/files/1/0806/1308/1387/files/left-chevron.png?v=1715172263'/></button>",
  nextArrow:
    "<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0806/1308/1387/files/chevron.png?v=1715172263'/></button>",
});
